import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import logo from "../images/logo.webp";

const navItems = [
  "Home",
  "About",
  "Classes",
  "Blog",
  "Contact",
];

const Navbar = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <AppBar
      elevation={0}
      sx={{
        display: "flex",
        backgroundColor: "#fff",
        color: "#000",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        boxShadow: "0px 0px 4px 0px #333",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px",
        }}
      >
        {/* Logo on the right */}
        <Box component="img" src={logo} sx={{ width: 140, height: 110 }} />
        {/* Navigation items on the left */}
        <Box sx={{ marginRight: "50px" }}>
          {navItems.map((item) => (
            <Button
              key={item}
              sx={{
                color: "#000",
                fontSize: "16px",
                padding: "20px",
                textTransform: "none",
                fontFamily: "poppins",
                ":hover": {
                  color: "#fff",
                  backgroundColor: "#E8921D",
                },
              }}
              onClick={() => {
                if (item === "About") handleNavigate("/about");
                if (item === "Classes") handleNavigate("/classes");
                if (item === "Contact") handleNavigate("/contact");
                if (item === "Blog") handleNavigate("/blogs");
                if (item === "Home") handleNavigate("/");
              }}
            >
              {item}
            </Button>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
